import styled from 'styled-components';
import LoadingOverlay from 'react-loading-overlay';

export const AppContentInner = styled.div`
  flex: 1;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 30px;
  margin: 30px 98px;
`;

export const AppContentAdaptive = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  padding: 30px;
  margin: 30px 98px;
`;

export const AppContentTitle = styled.h1`
  font-size: 24px;
  margin-top: 5px;
  margin-bottom: 25px;
  color: #073142;
  font-family: 'Open Sans Condensed', sans-serif;
  text-transform: uppercase;
`;

export const StyledLoader = styled(LoadingOverlay)`
  ._loading_overlay_overlay {
    background: rgba(205, 235, 245, 0.8);
    color: black;
    border-radius: 5px;
  }

  ._loading_overlay_content {
    display: flex;
    align-items: center;
  }

  ._loading_overlay_spinner {
    margin: 0;

    & svg circle {
      stroke: #073142;
    }
  }
`;
